import React, { useState, useEffect } from 'react';

const VehicleHSDFillingReportAllPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});

  // Get URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedParams = {
      branchid: urlParams.get('branchid') || '',
      branchtype: urlParams.get('branchtype') || 'HO',
      searchBranch: urlParams.get('searchBranch') || 'Select',
      vehicleCode: urlParams.get('vehicleCode') || '',
      vehicleName: urlParams.get('vehicleName') || '',
      vehicleRegNo: urlParams.get('vehicleRegNo') || '',
      fromDate: urlParams.get('fromDate') || '',
      toDate: urlParams.get('toDate') || '',
      month: urlParams.get('month') || 'Select',
      year: urlParams.get('year') || 'Select',
      vehicletypeIndex: urlParams.get('vehicletypeIndex') || 'Select',
      vehicleType: urlParams.get('vehicleType') || 'O'
    };
    setParams(extractedParams);
  }, []);

  console.log("params:", params);

  // Default data structure for fallback
  const defaultReportData = {
    branchName: "HEAD-OFFICE",
    items: [],
    totalRecords: 0
  };

  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      if (!params.branchid) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Build API URL with parameters
        const apiParams = new URLSearchParams({
          branchid: params.branchid,
          branchtype: params.branchtype,
          searchBranch: params.searchBranch,
          vehicleCode: params.vehicleCode,
          vehicleName: params.vehicleName,
          vehicleRegNo: params.vehicleRegNo,
          fromDate: params.fromDate,
          toDate: params.toDate,
          month: params.month,
          year: params.year,
          vehicletypeIndex: params.vehicletypeIndex,
          vehicleType: params.vehicleType
        });

        
        const apiUrl = `https://www.nissi-india.com/api/hsd_filling_report?${apiParams.toString()}`;

        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        console.log("Fetched Vehicle HSD data:", res);
        
        // Check if API call was successful
        if (!res.success && res.success !== undefined) {
          throw new Error('API returned unsuccessful response');
        }

        // Format date function
        const formatDate = (dateString) => {
          if (!dateString) return '';
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        };

        // Transform API data to match our component structure
        const apiData = res.data || [];
        
        const transformedData = {
          branchName: apiData[0]?.fld_BranchName || "HEAD-OFFICE",
          totalRecords: apiData.length,
          items: apiData.map((item, index) => ({
            sNo: index + 1,
            vehicleCode: item.fld_vehicle_code || item.vehicleCode || "",
            vehicleName: item.fld_vehicle_name || item.vehicleName || "",
            vehicleRegNo: item.fld_vehicle_regno || item.vehicleRegNo || "",
            totalWorkingHr: item.fld_fld_hsdfillingWorkinhr || item.totalWorkingHr || "0",
            totalHSDFilling: item.fld_hsdfillinghr || item.totalHSDFilling || "0",
            totalWorkingKm: item.fld_hsdfillingWorkingKM || item.totalWorkingKm || "0",
            totalHSDFillingKm: item.fld_hsdfillingkm || item.totalHSDFillingKm || "0",
            dieselConsumHr: item.fld_diselconsumptionhr || item.dieselConsumHr || "0",
            dieselConsumKm: item.fld_diselconsumptionkm || item.dieselConsumKm || "0",
            lastUpdatedHr: item.cumulativehrs || item.lastUpdatedHr || "",
            lastUpdatedKM: item.cumulativekm|| item.lastUpdatedKM || "",
            lastUpdatedDate:item.fld_progressentrydate || formatDate(item.lastUpdatedDate) || ""
          })),
        };

        setReportData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching Vehicle HSD report data:', err);
        setError(err.message);
        setReportData(defaultReportData);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [params]);

  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Vehicle HSD report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load Vehicle HSD report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning (if using fallback data) */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Could not fetch data from API ({error}). Showing template.
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center border-b-2 border-black pb-2 mb-4 print:border-black">
          <h2 className="text-lg font-bold underline">VEHICLE HSD FILLING HR/KM REPORT</h2>
        </div>

        {/* Vehicle HSD Table */}
        <div className="border-2 border-black mb-4 print:border-black overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-1 py-2 text-center w-12 print:border-black">S.no</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Vehicle Code</th>
                <th className="border border-black px-1 py-2 text-center w-24 print:border-black">Vehicle Name</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Vehicle Regno</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total Working Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total HSD Filling</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total Working Km</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total HSD Filling</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consum Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consum Km</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Last Updated Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Last Updated KM</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Last Updated Date</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.vehicleCode}</td>
                  <td className="border border-black px-1 py-1 print:border-black">{item.vehicleName}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.vehicleRegNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.totalWorkingHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.totalHSDFilling}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.totalWorkingKm}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.totalHSDFillingKm}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.dieselConsumHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.dieselConsumKm}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.lastUpdatedHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.lastUpdatedKM}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.lastUpdatedDate}</td>
                </tr>
              ))}

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="13">
                    <div className="text-gray-500">
                      No vehicle HSD records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 8px !important;
          }
          .text-green-600 {
            color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default VehicleHSDFillingReportAllPrint;